
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v/register",
      function () {
        return require("private-next-pages/v/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v/register"])
      });
    }
  